
import React from 'react';
import { Button } from '@/components/ui/button';
import { CardHeader, CardTitle } from '@/components/ui/card';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

interface InvoiceFormHeaderProps {
  estimateId: string;
  estimateNumber?: string;
  estimateTitle?: string;
}

const InvoiceFormHeader: React.FC<InvoiceFormHeaderProps> = ({
  estimateId,
  estimateNumber,
  estimateTitle
}) => {
  return (
    <CardHeader>
      <div className="flex items-center gap-2 mb-2">
        <Button variant="ghost" size="sm" asChild>
          <Link to={`/estimates/${estimateId}`}>
            <ArrowLeft className="h-4 w-4 mr-1" />
            Back to Estimate
          </Link>
        </Button>
      </div>
      <CardTitle>Create Invoice</CardTitle>
      <p className="text-sm text-muted-foreground">
        Creating invoice for estimate: {estimateNumber} - {estimateTitle}
      </p>
    </CardHeader>
  );
};

export default InvoiceFormHeader;
